import InstagramFooterIconSVG from "../../assets/icons/svg/InstagramFooterIconSVG";
import YoutubeFooterIconSVG from "../../assets/icons/svg/YoutubeFooterIconSVG";
import FacebookFooterIconSVG from "../../assets/icons/svg/FacebookFooterIconSVG";


const SidebarFooter = () => {

    return (
        <div style={styles.footer}>

            <a
                href="https://www.instagram.com"
                target="_blank"
                style={styles.hrefStyle}
            >
                <InstagramFooterIconSVG />
            </a>

            <a
                href="https://www.youtube.com"
                target="_blank"
                style={styles.hrefStyle}
            >
                <YoutubeFooterIconSVG />
            </a>

            <a
                href="https://www.facebook.com"
                target="_blank"
                style={styles.hrefStyle}
            >
                <FacebookFooterIconSVG />
            </a>

        </div>
    )

};

export default SidebarFooter;

const styles = {
    footer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    hrefStyle: {
        cursor: 'pointer'
    }
}